import { render, staticRenderFns } from "./LocalCalendarListItem.vue?vue&type=template&id=25c8b119"
import script from "./LocalCalendarListItem.vue?vue&type=script&lang=ts"
export * from "./LocalCalendarListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25c8b119')) {
      api.createRecord('25c8b119', component.options)
    } else {
      api.reload('25c8b119', component.options)
    }
    module.hot.accept("./LocalCalendarListItem.vue?vue&type=template&id=25c8b119", function () {
      api.rerender('25c8b119', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/LocalCalendarListItem.vue"
export default component.exports